/* eslint-disable object-property-newline */
import React, { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useParams,
} from "react-router-dom";
import {
  useDispatch,
  useSelector
} from "react-redux";
import { withTranslation } from "react-i18next";
import { fetchClientDetails } from "store/client/actions";
import ClientProfile from "pages/ClientDetail/Profile/ClientProfile";
import ClientBank from "pages/ClientDetail/Bank/ClientBank";
import Documents from "pages/ClientDetail/Documents/Documents";
import ListAccounts from "pages/ClientDetail/TradingAccounts/ListAccounts";
import ClientTransactionsIndex from "pages/ClientDetail/Transactions/ClientTransactionsIndex";
import ClientWallets from "pages/ClientDetail/Wallets/ClientWallets";
import OrderList from "pages/ClientDetail/orders/OrdersList";
import Logs from "pages/ClientDetail/Logs";
import Notes from "pages/ClientDetail/Notes";
import Converts from "pages/ClientDetail/Converts/Converts";
import Security from "pages/ClientDetail/Security/Security";
import Partnership from "pages/ClientDetail/Partnership";
import Referral from "pages/ClientDetail/Referral";
import Statement from "pages/ClientDetail/Statement";
import ClientDetailsHeader from "pages/ClientDetail/ClientDetailsHeader";
import Layout from "pages/ClientDetail/Layout";
import ClientEvents from "pages/ClientDetail/Events/ClientEvents";

function LeadMainPage() {
  const pathParams = useParams();
  const dispatch = useDispatch();
  const { profileMetaInfo } = useSelector(state => state.Profile);
  const {
    clientDetails,
    clientProfileError,
    clientProfileloading,
    convertToIb,
    clearingCounter,
  } = useSelector(state => ({
    clientDetails: state.clientReducer.clientDetails,
    clientProfileloading: state.clientReducer.clientProfileloading,
    clientProfileError: state.clientReducer.clientProfileError,
    convertToIb: state.clientReducer.convertToIb,
    clearingCounter: state.clientReducer.clearingCounter,
  }));

  // const history = useHistory();
  const clientId = pathParams.id;

  // getting client details to check if client exists using their Id
  const getClientDetails = async (clientId) => {
    dispatch(fetchClientDetails(clientId));
  };

  const tabsArr = ({ clientDetails = {} }) => [
    {
      component: ClientProfile,
      url: "/leads/:clientId/profile",
      hidden: !clientDetails.profile,
    },
    {
      component: ClientBank,
      url: "/leads/:clientId/bank",
      hidden: !clientDetails.bankAccounts,
    },
    {
      component: Documents,
      url: "/leads/:clientId/documents",
      hidden: !clientDetails.documents,
    },
    {
      component: ListAccounts,
      url: "/leads/:clientId/trading-accounts",
      hidden: !clientDetails.tradingAccounts,
    },
    {
      component: ClientTransactionsIndex,
      url: "/leads/:clientId/transactions",
      hidden: !clientDetails.transactions,
    },
    {
      component: ClientWallets,
      url: "/leads/:clientId/wallets",
      // hidden: !clientDetails.wallets,
    },
    {
      component: OrderList,
      url: "/leads/:clientId/orders",
      hidden: !clientDetails.orders,
    },
    {
      component: Logs,
      url: "/leads/:clientId/logs",
      hidden: !clientDetails.logs,
    },
    {
      component: Notes,
      url: "/leads/:clientId/notes",
      hidden: !clientDetails.notes,
    },
    {
      component: Converts,
      url: "/leads/:clientId/converts",
      hidden: !clientDetails.converts,
    },
    {
      component: Security,
      url: "/leads/:clientId/security",
      hidden: !clientDetails.security,
    },
    {
      component: Partnership,
      url: "/leads/:clientId/partnership",
      hidden: !clientDetails.partnership,
    },
    {
      component: Referral,
      url: "/leads/:clientId/referral",
      hidden: !clientDetails.referral,
    },
    {
      component: Statement,
      url: "/leads/:clientId/statement",
      hidden: !clientDetails.statement,
    },
    {
      component: ClientEvents,
      url: "/leads/:clientId/events",
    },
  ];

  useEffect(() => {
    getClientDetails(clientId);
  }, [clientId, convertToIb, clearingCounter]);

  return (
    <React.Fragment>
      {clientDetails && (
        <div className="page-content">
          <div className="container-fluid">
            <ClientDetailsHeader
              clientId={clientId}
            />
            <Switch>
              {!clientProfileError ? (
                <Layout
                  clientId={clientId}
                  isIb={clientDetails.fx?.isIb}
                  isLead={clientDetails.isLead}
                >
                  {tabsArr(profileMetaInfo || {}).filter(item => !item.hidden).map((obj, index) => (
                    <Route key={index} exact path={obj.url}>
                      <obj.component clientId={clientId} path={obj.url} />
                    </Route>
                  ))}
                </Layout>
              ) : (
                <Redirect to={"/dashboard"} />
              )}
            </Switch>
          </div>
        </div>
      )}
      {!clientProfileloading && !clientDetails && (
        <React.Fragment>
          <div className="page-content">
            <div className="container-fluid text-center">
              <h2>Data not found, please add your design logic here</h2>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default (withTranslation()(LeadMainPage));